import { UISystem } from "../../../system/ui/UISystem";
import { title } from "elmtree";
export function ControlsScreen() {
    UISystem.appScreen.screens.add([
        {
            id: "controls",
            getElements() {
                return [title("h1", "Controls", "screen-title")];
            },
        },
    ]);
}
